import * as React from "react";
import { injectGlobal } from "styled-components";

import ModalPortal from "./components/modal/ModalPortal";
import PopoverPortal from "./components/popover/PopoverPortal";
import { LazyImageContextProvider } from "./components/lazy";
import ScreenSizeObserver from "./components/ScreenSizeObserver";

const lazyImageContextProviderOptions = {
  rootMargin: "300px",
  threshold: 0.0,
};

const Root: React.SFC<{}> = props => {
  return (
    <>
      <LazyImageContextProvider options={lazyImageContextProviderOptions}>
        {props.children}
        <ModalPortal name="default" />
        <PopoverPortal name="default" />
      </LazyImageContextProvider>
      <ScreenSizeObserver />
    </>
  );
};

export default Root;

// tslint:disable-next-line:no-unused-expression
injectGlobal`
  #container {
    min-width: auto;
  }
  #main {
    margin-top: 0;
    margin-bottom: 0;
  }
  #main-inner {
    width: auto;
  }
`;



// WEBPACK FOOTER //
// ./frontend/src/common/Root.tsx